import { render } from "./StatisticsResultsSsx.vue?vue&type=template&id=84edf444"
import script from "./StatisticsResultsSsx.vue?vue&type=script&lang=js"
export * from "./StatisticsResultsSsx.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Statistics/StatisticsResultsSsx.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84edf444"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84edf444', __exports__)) {
    api.reload('84edf444', __exports__)
  }
  
  module.hot.accept("./StatisticsResultsSsx.vue?vue&type=template&id=84edf444", () => {
    api.rerender('84edf444', render)
  })

}


export default __exports__